import { render } from "./SearchResultSalesDocument.vue?vue&type=template&id=2acdc526"
import script from "./SearchResultSalesDocument.vue?vue&type=script&lang=js"
export * from "./SearchResultSalesDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__